import React from "react";

export function Sub( props: React.SVGProps<SVGSVGElement> ) {
    return (
        <svg width="18" height="3" viewBox="0 0 18 3" fill="none" {...props}>
            <path d="M3 0.5H15V2.5H3V0.5Z" fill="currentColor" />
        </svg>
    );
}
